module.exports = __webpack_public_path__ + "static/img/example3.673f4b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chainmanage/image/example3.jpg
// module id = 709
// module chunks = 1